import { createRoot } from 'react-dom/client';
import App from './app/App.jsx';
import { initDatadog } from './app/datadog.js';
import { initAccent, initDensity, initThemeMode } from './lib';
import { captureInitialOfferToken } from './pages/oferta/offerToken.js';

// Remove the email credential before observability or React starts.
captureInitialOfferToken();

// Initialize observability before mounting React so we capture early errors,
// long tasks, and resource timings from the very first render.
initDatadog();

// Apply persisted preferences on <html> before render to avoid a flash.
initThemeMode();
initAccent();
initDensity();

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);
